module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_des_Kantons_Schwyz-cdb11dc4c65b6088b2b9ea48fe93e792.svg";